import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/hooks/useAuth";
import ProductUploadContent from "@/components/ProductUploadContent";

export default function ProductUpload() {
  const { user } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (user && user.role !== 'admin') {
      navigate('/dashboard');
      toast.error('Access denied. Admin privileges required.');
    }
  }, [user, navigate]);

  if (user?.role !== 'admin') return null;

  return <ProductUploadContent isAdmin={true} />;
}
